import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  init() {
    this.hours = this.el.querySelector('[data-opening-hours]')
    this.day = this.el.querySelector('[data-opening-day]')
    this.who = this.el.querySelector('[data-opening-who]')
    this.name = this.who.innerHTML

    this.lang = document.documentElement.lang
    this.open = 'is open'
    this.closed = 'is closed'

    switch (this.lang) {
      case 'nl-BE':
        this.open = 'is open'
        this.closed = 'is gesloten'
        break
      case 'en-GB':
        this.open = 'is open'
        this.closed = 'is closed'
        break
      case 'fr-BE':
        this.open = 'est ouvert'
        this.closed = 'est fermé'
        break
    }

    this.refresh()
    setInterval(() => {
      this.refresh()
    }, 60000)
  }

  check() {
    const now = new Date()
    const formattedDD = now.getDate().toString().padStart(2, '0')
    const formattedMM = (now.getMonth() + 1).toString().padStart(2, '0')
    const formattedYYYY = now.getFullYear()
    const formattedNow = `${formattedDD}/${formattedMM}/${formattedYYYY}`

    let isClosedDay
    window.closedDays.forEach((obj) => {
      if (obj.day === formattedNow) {
        isClosedDay = true
      }
    })

    if (isClosedDay) {
      this.state = false
      return
    }

    const day = now.getDay() - 1 === -1 ? 6 : now.getDay() - 1
    const openings = window.openings[day]

    if (openings) {
      const start = new Date()
      start.setHours(openings.hour_start.split(':')[0])
      start.setMinutes(openings.hour_start.split(':')[1])

      const end = new Date()
      end.setHours(openings.hour_end.split(':')[0])
      end.setMinutes(openings.hour_end.split(':')[1])

      if (now >= start && now <= end) {
        this.state = true
      } else {
        this.state = false
      }
      return
    }

    this.state = false
  }

  refresh() {
    const date = new Date()
    const hours = date.getHours()
    const minutes = date.getMinutes()
    const day = date.getDate()
    const month = date.getMonth() + 1

    this.hours.innerHTML = `${hours}:${minutes < 10 ? `0${minutes}` : minutes}`
    this.day.innerHTML = `${day < 10 ? `0${day}` : day}.${month < 10 ? `0${month}` : month}`

    this.check()

    if (this.state) {
      this.who.innerHTML = `${this.name} ${this.open}`
    } else {
      this.who.innerHTML = `${this.name} ${this.closed}`
    }
  }
}
